import { call, all, put, takeLatest } from "redux-saga/effects";
import { doGet } from "../utils/request";
import {
  getTotalETOSuccess,
  getTotalETOFail,
  getTotalETISuccess,
  getTotalETIFail,
  getTotalPaidUnpaidPendingTaxSuccess,
  getTotalPaidUnpaidPendingTaxFail,
  getAdminUsersListSuccess,
  getAdminUsersListFail,
  getTotalRegisteredPropertiesFiscalYearSuccess,
  getTotalRegisteredPropertiesFiscalYearFail
} from "../actionCreators/HomePage";

function* getTotalETO({obj}) {
  try {
    const response = yield doGet(`/user/etos?district_id=${obj ?? ''}`);
    yield put(getTotalETOSuccess(response.data));
  } catch (err) {
    yield put(getTotalETOFail(err.response.data.message || err.message));
    yield put(getTotalETOFail());
  }
}

function* getTotalETI({obj}) {
  try {
    const response = yield doGet(`/user/inspectors?district_id=${obj ?? ''}`);
    yield put(getTotalETISuccess(response.data));
  } catch (err) {
    yield put(getTotalETIFail(err.response.data.message || err.message));
    yield put(getTotalETIFail());
  }
}

function* getTotalPaidUnpaidPendingTax({obj}) {
  try {
    const response = yield doGet(`/homepage/getTotalPaidUnpaidPendingTax?district_id=${obj ?? ''}`);
    yield put(getTotalPaidUnpaidPendingTaxSuccess(response.data));
  } catch (err) {
    yield put(
      getTotalPaidUnpaidPendingTaxFail(err.response.data.message || err.message)
    );
    yield put(getTotalPaidUnpaidPendingTaxFail());
  }
}

function* getAdminUsersList({ obj }) {
  try {
    const response = yield doGet(
      `/homepage/getAllUsers?page=${obj.page}&pageSize=${obj.pageSize
      }&userName=${[undefined, null, ""].includes(obj.searchString)
        ? `""`
        : `"${obj.searchString}"`
      }&filter=${obj?.filterBody}`
    );
    yield put(getAdminUsersListSuccess(response.data));
  } catch (err) {
    yield put(getAdminUsersListFail(err.response.data.message || err.message));
    yield put(getAdminUsersListFail());
  }
}

function* getTotalRegisteredPropertiesFiscalYear({ obj }) {
  try {
    const response = yield doGet(
      `/homepage/getPropertiesRegisteredThisFiscalYear`
    );
    yield put(getTotalRegisteredPropertiesFiscalYearSuccess(response.data));
  } catch (err) {
    yield put(getTotalRegisteredPropertiesFiscalYearFail(err.response.data.message || err.message));
  }
}

export default function* watcher() {
  yield all([
    takeLatest("GET_TOTAL_ETO", getTotalETO),
    takeLatest("GET_TOTAL_ETI", getTotalETI),
    takeLatest(
      "GET_TOTAL_PAID_UNPAID_PENDING_TAX",
      getTotalPaidUnpaidPendingTax
    ),
    takeLatest("GET_ADMIN_USERS_LIST", getAdminUsersList),
    takeLatest('GET_TOTAL_REGISTERED_PROPERTIES_FISCAL_YEAR', getTotalRegisteredPropertiesFiscalYear),
  ]);
}
